
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ieevf", function(module, exports) {
/* CollapsibleSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $6R5uz = parcelRequire("6R5uz");


var $ghftu = parcelRequire("ghftu");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $5izcQ = parcelRequire("5izcQ");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $gz8ZY = parcelRequire("gz8ZY");


var $luv00 = parcelRequire("luv00");




const $0d5ed51ad4adb9fe$export$f680877a34711e37 = ()=>(0, $42omo.useMemo)(()=>{
        const randomId = Math.floor(10000000 + Math.random() * 90000000); // Generates an 8-digit number
        return `collapsible-section-${randomId}`;
    }, []);
const $0d5ed51ad4adb9fe$export$837c8b193a11611d = (headerId)=>`${headerId}-content`;


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87ec17fa27698ae5$var$HeaderAreaGrid = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _14ua1dpa",
            __cmplp.className
        ])
    });
});
const $87ec17fa27698ae5$var$CollapsibleSectionHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8i4vh _1yt411wb _19itglyw _2rkofajl _1ii7kb7n _yyhykb7n _1e0c1txw _4t3i14no _1bsb1osq _bfhkvuon _80omtlke _4cvr1h6o _kqswh2mm _syazi7uo _irr31dpa",
            __cmplp.className
        ])
    });
});
const $87ec17fa27698ae5$var$NewFeaturesCollapsibleSectionHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1yt4m31d _19itglyw _1ii7kb7n _yyhykb7n _1e0c1txw _4t3i14no _1bsb1osq _bfhkvuon _4cvr1h6o _kqswh2mm _syazi7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87ec17fa27698ae5$var$CollapsibleSectionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_yponidpf",
            __cmplp.isOpen ? "_otyrf6fq" : "_otyridpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87ec17fa27698ae5$var$FadeInContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v564fs5d",
            __cmplp.isOpen ? "_tzy41osq" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $87ec17fa27698ae5$var$AfterIconButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81guz _1ii7kb7n _yyhykb7n _1e0c1txw _1bahesu3 _4t3i1tcg _1bsb1tcg _10fph9n0 _1ur0h2mm _c6vaa982 _if2h1tcg _16z51tcg _f04l1tcg _jwon1txw _pxv31h6o _it9u1h6o _dhha7vkz _174l7vkz _1x5k1diz _162a1q3r",
            __cmplp.className
        ])
    });
});
const $87ec17fa27698ae5$var$tooltipStyles = null;
const $87ec17fa27698ae5$export$42e68d87a106633c = /*#__PURE__*/ (0, $42omo.forwardRef)(function WiderTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c8wadc _1rjc1b66 _18zr12x7 _p12f1mjv _syaz15cr"
        ])
    }, children);
});
const $87ec17fa27698ae5$var$beforeIconColor = "var(--ds-icon-accent-gray, #7D818A)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87ec17fa27698ae5$var$BeforeIconBorder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko12b0 _kqswstnw _1bsbqslr _4t3iqslr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87ec17fa27698ae5$var$SectionTitle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _18u0u2gc _syaz1sqi _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $87ec17fa27698ae5$export$c34b9f1cc8038b19 = ({ children: children })=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.075",
        "data-vc": "empty-sidebar-collapsible-section-container",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.075",
        paddingInlineStart: "space.150",
        "data-vc": "empty-sidebar-collapsible-section-container",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, children));
};
const $87ec17fa27698ae5$var$BeforeIcon = ({ isOpen: isOpen, showBorder: showBorder = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, showBorder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$BeforeIconBorder, null), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: $87ec17fa27698ae5$var$beforeIconColor,
        spacing: "spacious",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: "",
        color: $87ec17fa27698ae5$var$beforeIconColor,
        spacing: "spacious",
        size: "small"
    }));
const $87ec17fa27698ae5$var$CollapsibleHeader = ({ renderAfterIconButton: renderAfterIconButton, headerTitle: headerTitle, id: id, isOpen: isOpen, onClick: onClick, tooltipProps: tooltipProps, setHeaderExpandedState: setHeaderExpandedState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$HeaderAreaGrid, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$CollapsibleSectionHeader, {
        ...tooltipProps,
        onClick: ()=>onClick(),
        id: id,
        "aria-expanded": isOpen,
        "aria-controls": (0, $0d5ed51ad4adb9fe$export$837c8b193a11611d)(id),
        "data-testid": headerTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$BeforeIcon, {
        isOpen: isOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$SectionTitle, null, headerTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$FadeInContainer, {
        isOpen: isOpen
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$AfterIconButtonWrapper, null, renderAfterIconButton(setHeaderExpandedState)));
const $87ec17fa27698ae5$var$NewFeaturesCollapsibleHeader = ({ headerTitle: headerTitle, isOpen: isOpen, id: id, onClick: onClick, tooltipProps: tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$HeaderAreaGrid, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$NewFeaturesCollapsibleSectionHeader, {
        ...tooltipProps,
        onClick: ()=>onClick(),
        id: id,
        "aria-expanded": isOpen,
        "aria-controls": (0, $0d5ed51ad4adb9fe$export$837c8b193a11611d)(id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$BeforeIcon, {
        isOpen: isOpen,
        showBorder: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$SectionTitle, null, headerTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$FadeInContainer, {
        isOpen: isOpen
    })));
const $87ec17fa27698ae5$var$TooltipContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $87ec17fa27698ae5$export$55b973e094275b13 = ({ initialExpandedState: initialExpandedState = true, ...props })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(initialExpandedState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$export$6f3c0db6d4174d9d, {
        ...props,
        isOpen: isOpen,
        setIsOpen: setIsOpen
    });
};
const $87ec17fa27698ae5$export$6f3c0db6d4174d9d = ({ renderAfterIconButton: renderAfterIconButton, children: children, headerTitle: headerTitle, onClick: onClick = ()=>{}, updateExpandedState: updateExpandedState, tooltipContent: tooltipContent, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const headerId = (0, $0d5ed51ad4adb9fe$export$f680877a34711e37)();
    const setHeaderExpandedState = (newIsOpen)=>{
        if (newIsOpen !== isOpen) {
            updateExpandedState?.(newIsOpen);
            setIsOpen(newIsOpen);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$CollapsibleSectionWrapper, {
        "data-vc": "collapsible-section-wrapper",
        ...ssrPlaceholderIdProp,
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "sideNavCollapsibleSectionSpotlight"
    }, tooltipContent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$CollapsibleHeader, {
        renderAfterIconButton: renderAfterIconButton,
        headerTitle: headerTitle,
        isOpen: isOpen,
        id: headerId,
        setHeaderExpandedState: setHeaderExpandedState,
        onClick: ()=>{
            onClick(isOpen);
            setIsOpen(!isOpen);
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        component: $87ec17fa27698ae5$export$42e68d87a106633c,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$TooltipContainer, null, tooltipContent)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$CollapsibleHeader, {
            tooltipProps: tooltipProps,
            renderAfterIconButton: renderAfterIconButton,
            headerTitle: headerTitle,
            isOpen: isOpen,
            id: headerId,
            setHeaderExpandedState: setHeaderExpandedState,
            onClick: ()=>{
                onClick(isOpen);
                setIsOpen(!isOpen);
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$FadeInContainer, {
        isOpen: isOpen,
        id: (0, $0d5ed51ad4adb9fe$export$837c8b193a11611d)(headerId),
        role: "region",
        "aria-labelledby": headerId
    }, isOpen && children));
};
const $87ec17fa27698ae5$export$12d089453a008ea4 = ({ headerTitle: headerTitle, tooltipContent: tooltipContent, children: children })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const headerId = (0, $0d5ed51ad4adb9fe$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$CollapsibleSectionWrapper, {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        component: $87ec17fa27698ae5$export$42e68d87a106633c,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$TooltipContainer, null, tooltipContent)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$NewFeaturesCollapsibleHeader, {
            tooltipProps: tooltipProps,
            headerTitle: headerTitle,
            id: headerId,
            onClick: ()=>{
                setIsOpen(!isOpen);
            },
            isOpen: isOpen
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ec17fa27698ae5$var$FadeInContainer, {
        isOpen: isOpen,
        id: (0, $0d5ed51ad4adb9fe$export$837c8b193a11611d)(headerId),
        role: "region",
        "aria-labelledby": headerId
    }, isOpen && children));
};
module.exports["WiderTooltip"] = $87ec17fa27698ae5$export$42e68d87a106633c;
module.exports["EmptySidebarCollapsibleSectionContainerWrapper"] = $87ec17fa27698ae5$export$c34b9f1cc8038b19;
module.exports["CollapsibleSection"] = $87ec17fa27698ae5$export$55b973e094275b13;
module.exports["ControlledCollapsibleSection"] = $87ec17fa27698ae5$export$6f3c0db6d4174d9d;
module.exports["NewFeaturesCollapsibleSection"] = $87ec17fa27698ae5$export$12d089453a008ea4;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});


//# sourceMappingURL=CollapsibleSection.abb8ce2d.js.map
